/**
 * Microsoft Store Plus IAP — single monthly subscription.
 * Partner Center Product ID: notesplus_plus_monthly
 * Prices come from Microsoft Store (do not hardcode TL amounts in UI).
 */
export const STORE_PLUS_MONTHLY_STORE_ID = '9MSMQZZ7JRGX';
export const STORE_PLUS_MONTHLY_PRODUCT_ID = 'notesplus_plus_monthly';
export const STORE_PLUS_PRODUCT_IDS = [STORE_PLUS_MONTHLY_STORE_ID];
